import {
  CUSTOM_PRICE_RANGE_FILTER_ID,
} from './filterConstants';
import {generateCustomPriceRangeFilterName, generateCustomPriceRangeFilterValue} from './priceFilterUtils';

class Filter {
  static fromPriceRange(priceRange) {
    return new Filter({
      id: CUSTOM_PRICE_RANGE_FILTER_ID,
      value: generateCustomPriceRangeFilterValue(priceRange),
      name: generateCustomPriceRangeFilterName(priceRange),
    });
  }

  static fromWordFilter(keyword) {
    return new Filter({
      id: keyword,
      value: keyword,
      name: keyword,
    });
  }

  static fromPojo(pojo) {
    return {
      ...pojo,
    };
  }

  static fromRawAppliedFilter(rawAppliedFilter, facet) {
    return {
      id: rawAppliedFilter.id,
      value: rawAppliedFilter.value,
      mordorValue: rawAppliedFilter.mordorValue,
      name: rawAppliedFilter.name,
      isAutoApplied: rawAppliedFilter.isAutoApplied,
      customFilterId: rawAppliedFilter.customFilterId,
      title: facet?.title || '',
      isSelected: true,
      itemsCount: 0,
      category: null,
    };
  }

  constructor(rawFilter = {}) {
    this.id = rawFilter.id;
    this.value = rawFilter.value || rawFilter.mordorValue || null;
    this.name = rawFilter.name;
    this.isSelected = Boolean(rawFilter.isSelected);
    this.itemsCount = rawFilter.itemsCount || 0;
    this.category = rawFilter.category || null;
    this.isAutoApplied = rawFilter.isAutoApplied || false;
    this.mordorId = rawFilter.mordorId;
    this.customFilterId = rawFilter.customFilterId || rawFilter.id;
    this.title = rawFilter.title || '';
    this.mordorValue = rawFilter.mordorValue;
    this.href = rawFilter.href || null;
    this.hrefTitle = rawFilter.hrefTitle || null;
    this.boostType = rawFilter.boostType || null;
    this.urlForRedirection = rawFilter.urlForRedirection || '';
    this.urlForParams = rawFilter.urlForParams || '';
  }

  hashCode() {
    return 0;
  }

  equals(other) {
    return other.id === this.id;
  }
}

export default Filter;
